import { isMobileAtom, useRecoil } from '@orcar/common-d2c';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import AgreementOfferPrivacy from './components/AgreementOfferPrivacy';
import AgreementRentPolicy from './components/AgreementRentPolicy';
import CommercePolicy from './components/CommercePolicy';
import Privacy from './components/Privacy';
import TravelPolicy from './components/TravelPolicy';

const PolicyPage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  // useEffect(() => {
  //   switch (queryString) {
  //     case 'travel':
  //       return setImgUrl(TravelPolicy);
  //     case 'privacy':
  //       return setImgUrl(PrivacyPolicy);
  //     case 'commerce':
  //       return setImgUrl(CommercePolicy);
  //     case 'rent':
  //       return setImgUrl(RentPolicy);
  //     case 'agreement-non-member-privacy':
  //       return setImgUrl(AgreementNonMemberPrivacy);
  //     case 'agreement-offer-privacy':
  //       return setImgUrl(AgreementOfferPrivacy);
  //     case 'agreement-payment-privacy':
  //       return setImgUrl(AgreementPaymentPrivacy);
  //     case 'agreement-rent':
  //       return setImgUrl(RentPolicy);
  //     default:
  //       return;
  //   }
  // }, [queryString]);
  return (
    <Wrapper isMobile={isMobile}>
      {type === 'travel' ? (
        <TravelPolicy />
      ) : type === 'privacy' ? (
        <Privacy />
      ) : type === 'commerce' ? (
        <CommercePolicy />
      ) : type === 'agreement-rent' || type === 'rent' ? (
        <AgreementRentPolicy />
      ) : type === 'agreement-offer-privacy' ? (
        <AgreementOfferPrivacy />
      ) : null}
    </Wrapper>
  );
};

export default PolicyPage;

const Wrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  width: 100%;
  margin-top: ${({ isMobile }) => (isMobile ? '0' : '-40px')};
`;
